import { request, success, failure, TEAMS_REQUEST } from "./utilities";
import { getTeamsList, addTeam, removeTeam } from "../api";
import { TeamData } from "../../utils/dummyData";


export function getAllTeams() {
    return (dispatch) => {
        dispatch(success(TEAMS_REQUEST.GET_ALL_TEAMS_SUCCESS, TeamData));
        // dispatch(request(TEAMS_REQUEST.GET_ALL_TEAMS_REQUEST));
        // getTeamsList().then((res) => {
        //     if (res.data.status === 1) {
        //         dispatch(success(TEAMS_REQUEST.GET_ALL_TEAMS_SUCCESS, res.data.data));
        //     }
        //     else {
        //         dispatch(failure(TEAMS_REQUEST.GET_ALL_TEAMS_FAILURE, res.data.message));
        //     }
        // }, (error) => {
        //     dispatch(failure(TEAMS_REQUEST.GET_ALL_TEAMS_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
        // })
    }
}

export function addNewTeam(teamData) {
    return (dispatch) => {
        dispatch(request(TEAMS_REQUEST.ADD_NEW_TEAM_REQUEST));
        addTeam(teamData).then((res) => {
            if (res.data.status === 1) {
                dispatch(success(TEAMS_REQUEST.ADD_NEW_TEAM_SUCCESS, res.data.data));
            }
            else {
                dispatch(failure(TEAMS_REQUEST.ADD_NEW_TEAM_FAILURE, res.data.message));
            }
        }, (error) => {
            dispatch(failure(TEAMS_REQUEST.ADD_NEW_TEAM_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
        })
    }
}

export function editTeam(teamData) {
    return (dispatch) => {
        dispatch(request(TEAMS_REQUEST.EDIT_TEAM_REQUEST));
        addTeam(teamData).then((res) => {
            if (res.data.status === 1) {
                dispatch(success(TEAMS_REQUEST.EDIT_TEAM_SUCCESS, res.data.data));
            }
            else {
                dispatch(failure(TEAMS_REQUEST.EDIT_TEAM_FAILURE, res.data.message));
            }
        }, (error) => {
            dispatch(failure(TEAMS_REQUEST.EDIT_TEAM_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
        })
    }
}

export function deleteTeam(teamId) {
    return (dispatch) => {
        dispatch(success(TEAMS_REQUEST.DELETE_TEAM_SUCCESS, teamId));
        // dispatch(request(TEAMS_REQUEST.DELETE_TEAM_REQUEST));
        // removeTeam(teamId).then((res) => {
        //     if (res.data.status === 1) {
        //         dispatch(success(TEAMS_REQUEST.DELETE_TEAM_SUCCESS, res.data.data));
        //     }
        //     else {
        //         dispatch(failure(TEAMS_REQUEST.DELETE_TEAM_FAILURE, res.data.message));
        //     }
        // }, (error) => {
        //     dispatch(failure(TEAMS_REQUEST.DELETE_TEAM_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
        // })
    }
}